<label
  class="radio-container"
  [class.has-description]="description"
  [class.selected]="radioValue === value"
  [class.disabled]="disabled"
>
  <span class="radio-icon" [class.is-selected]="radioValue === value"></span>
  <input
    #radioInput
    type="radio"
    (change)="toggleCheck($event)"
    [name]="name"
    [value]="radioValue"
    [attr.checked]="radioValue === value ? 'checked' : null"
  />
  <span class="radio-text">
    <span class="label">{{ label }}</span>
    <span
      *ngIf="description"
      class="description"
      [innerHTML]="description"
    ></span>
  </span>
</label>

<ng-container *ngIf="value === radioValue && selectedContentTemplate">
  <div class="radio-content">
    <ng-container *ngTemplateOutlet="selectedContentTemplate"></ng-container>
  </div>
</ng-container>
